"use strict";
function _typeof(obj) {
    return (_typeof =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (obj) {
                  return typeof obj;
              }
            : function (obj) {
                  return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
              })(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        (descriptor.enumerable = descriptor.enumerable || !1), (descriptor.configurable = !0), "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
}
function _inherits(subClass, superClass) {
    if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
    (subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: !0, configurable: !0 } })), superClass && _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function () {
        var result,
            Super = _getPrototypeOf(Derived);
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    return !call || ("object" !== _typeof(call) && "function" != typeof call) ? _assertThisInitialized(self) : call;
}
function _assertThisInitialized(self) {
    if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _wrapNativeSuper(Class) {
    var _cache = "function" == typeof Map ? new Map() : void 0;
    return (_wrapNativeSuper = function (Class) {
        if (null === Class || !_isNativeFunction(Class)) return Class;
        if ("function" != typeof Class) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== _cache) {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        return (Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } })), _setPrototypeOf(Wrapper, Class);
    })(Class);
}
function _construct(Parent, args, Class) {
    return (_construct = _isNativeReflectConstruct()
        ? Reflect.construct
        : function (Parent, args, Class) {
              var a = [null];
              a.push.apply(a, args);
              var instance = new (Function.bind.apply(Parent, a))();
              return Class && _setPrototypeOf(instance, Class.prototype), instance;
          }).apply(null, arguments);
}
function _isNativeReflectConstruct() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (e) {
        return !1;
    }
}
function _isNativeFunction(fn) {
    return -1 !== Function.toString.call(fn).indexOf("[native code]");
}
function _setPrototypeOf(o, p) {
    return (_setPrototypeOf =
        Object.setPrototypeOf ||
        function (o, p) {
            return (o.__proto__ = p), o;
        })(o, p);
}
function _getPrototypeOf(o) {
    return (_getPrototypeOf = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (o) {
              return o.__proto__ || Object.getPrototypeOf(o);
          })(o);
}
if (!customElements.get("variant-picker")) {
    var VariantPicker = (function (_HTMLElement) {
        _inherits(VariantPicker, _wrapNativeSuper(HTMLElement));
        var _super = _createSuper(VariantPicker);
        function VariantPicker() {
            return _classCallCheck(this, VariantPicker), _super.call(this);
        }
        return (
            _createClass(VariantPicker, [
                {
                    key: "connectedCallback",
                    value: function () {
                        var _this = this;
                        this.addEventListener("change", function (event) {
                            var target = _this.getInputForEventTarget(event.target);
                            _this.updateSelectionMetadata(event),
                                eventBus.publish(SKU_EVENTS.optionValueSelectionChange, {
                                    data: { event: event, target: target, pickerType: _this.dataset.pickerType, selectedOptionValues: _this.selectedOptionValues, sectionId: "shopify-section-" + _this.dataset.section },
                                });
                        });
                    },
                },
                {
                    key: "getInputForEventTarget",
                    value: function (target) {
                        return "SELECT" === target.tagName ? target.selectedOptions[0] : target;
                    },
                },
                {
                    key: "updateSelectionMetadata",
                    value: function (_ref) {
                        var target = _ref.target,
                            value = target.value,
                            tagName = target.tagName;
                        if ("SELECT" === tagName && target.selectedOptions.length) {
                            Array.from(target.options)
                                .find(function (option) {
                                    return option.getAttribute("selected");
                                })
                                .removeAttribute("selected"),
                                target.selectedOptions[0].setAttribute("selected", "selected");
                            var swatchValue = target.selectedOptions[0].dataset.optionSwatchValue,
                                selectedDropdownSwatchValue = target.closest(".product-form__input").querySelector("[data-selected-value] > .swatch");
                            if (!selectedDropdownSwatchValue) return;
                            swatchValue
                                ? (selectedDropdownSwatchValue.style.setProperty("--swatch--background", swatchValue), selectedDropdownSwatchValue.classList.remove("swatch--unavailable"))
                                : (selectedDropdownSwatchValue.style.setProperty("--swatch--background", "unset"), selectedDropdownSwatchValue.classList.add("swatch--unavailable")),
                                selectedDropdownSwatchValue.style.setProperty("--swatch-focal-point", target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset");
                        } else if ("INPUT" === tagName && "radio" === target.type) {
                            var selectedSwatchValue = target.closest(".product-form__input").querySelector("[data-selected-value]");
                            selectedSwatchValue && (selectedSwatchValue.innerHTML = value);
                        }
                    },
                },
                {
                    key: "selectedOptionValues",
                    get: function () {
                        return Array.from(this.querySelectorAll("select option[selected], fieldset input:checked")).map(function (_ref2) {
                            return _ref2.dataset.optionValueId;
                        });
                    },
                },
            ]),
            VariantPicker
        );
    })();
    customElements.define("variant-picker", VariantPicker);
}
